module.exports = __webpack_public_path__ + "media/images/ui__textArrowLeft--dark-e4e984a22b150dd03599085cb289ec0a.png";